<template>
  <div class="centerContent">
    <b-button
      variant="link"
      class="arrowButtons"
      @click="SET_PREVIOUS_MONTH"
    >
      <b-icon-arrow-left />
    </b-button>

    <b-button
      variant="link"
      style="box-shadow: none;"
      @click="SET_TODAY"
    >
      Heute
    </b-button>

    <b-button
      variant="link"
      class="arrowButtons"
      @click="SET_NEXT_MONTH"
    >
      <b-icon-arrow-right />
    </b-button>
  </div>
</template>

<script>
import { BIconArrowLeft, BIconArrowRight, BButton } from 'bootstrap-vue'
import { mapMutations } from 'vuex'

export default {
  name: 'CalendarNavigationArrows',
  components: {
    BIconArrowLeft,
    BIconArrowRight,
    BButton
  },
  methods: {
    ...mapMutations('calendar', [
      'SET_PREVIOUS_MONTH',
      'SET_NEXT_MONTH',
      'SET_TODAY'
    ])
  }
}
</script>

<style scoped>

.centerContent {
  display: flex;
  justify-content: center
}

.arrowButtons {
  font-size: 24px;
  box-shadow: none;
}

</style>
